import React from 'react';
import {withRouter} from "react-router-dom";
import {BodySm, TitleXl, TitleSm} from "components/elements";
import { HowWeWorkContainer, HowWeWorkTopContainer, TitleXlContainer, BodySmContainer, LogoContainer,  TitleSmBodySmContainer, HealthCareExperienceContainer, TitleContainer, BottomCircleContainer, BottomLeftCircleContainer, BottomRightCircleContainer, CtaContainer } from './elements';
import OverlapCircles from 'components/OverlapCircles';
import ViewAll from "components/ViewAll";


function HowWeWorkSectoin () {


    return(
      <HowWeWorkContainer>
        <HowWeWorkTopContainer>
            <TitleXlContainer>
                <TitleXl color="#000" fontWeight="900">We believe there’s only one way to overcome the gaps in healthcare. </TitleXl>
            </TitleXlContainer>
            <BodySmContainer>
                <TitleSm >To not have any of our own. </TitleSm>
                <BodySm>With AI at our core and health’s widest range of expertise, we’re able to collaborate without barriers—no other company is better positioned to lead the transformative change our industry needs.</BodySm>
            </BodySmContainer>
       </HowWeWorkTopContainer>
       <LogoContainer>
            <TitleXl fontWeight="900" textTransform={"uppercase"}>HOW WE MAKE IT WORK</TitleXl>
            <img src={'/images/RC-logo.svg'} alt={'Real Chemistry logo'} className="realChemLogo"/>
       </LogoContainer>
       <img src={'/images/six-bu.svg'} alt="" className="sixBuImage" />
       <HealthCareExperienceContainer>
            <TitleContainer>
                <TitleXl color="#000">What if you could create the healthcare experience you wish you had?</TitleXl>
            </TitleContainer>
            <TitleSmBodySmContainer>
                <TitleSm>
                    We can. So that’s exactly what we do. 
                </TitleSm>
                <BodySm fontSize="20px">After all, we’re patients too. And we’re ready to create the future of healthcare.</BodySm>
            </TitleSmBodySmContainer>
       </HealthCareExperienceContainer>
       <BottomCircleContainer>
            <BottomLeftCircleContainer>
                <OverlapCircles borderColor="#A036F5" dimensionsDesktop="463px" dimensionsMobile="360px" header="false" mobileBorder={"8px solid #A036F5"} copyHeader={"AI-POWERED INSIGHTS"} subHead={"We understand healthcare audiences and opportunities like no one else"} bodyCopy={"With best-in-class AI and human interaction, we identify, walk in the shoes of and reach any audience—for any given condition."}/>
            </BottomLeftCircleContainer>
            <BottomRightCircleContainer>
                <OverlapCircles borderColor="#A036F5" dimensionsDesktop="463px" dimensionsMobile="360px" header="false"  mobileBorder={"8px solid #A036F5"} copyHeader={"IDEA-DRIVEN EXPERIENCES"} subHead={"We challenge ourselves to give the audience what they need, even if they don't know it yet"} bodyCopy={"Informed and inspired by deep human insights, we connect with the audience, influence the conversation and control the experience around life sciences products."}/>
            </BottomRightCircleContainer>
       </BottomCircleContainer>
       <CtaContainer>
            <ViewAll link="/contact" title={"GET IN TOUCH"} borderColor="#000" borderColorHover="#fff" titleColor="#000" hoverBackground="#000" width="214px" height="44px" svgColor="#000"  />
       </CtaContainer>

    </HowWeWorkContainer>
    )
}

export default withRouter(HowWeWorkSectoin);
